import React from "react";

const StarRatingList: React.FunctionComponent = ({ children }) => {
  return (
    <ul className="StarRatingList" role="list">
      {children}
    </ul>
  );
};

export default StarRatingList;
